jQuery(function($) {

/*--------------- Counter Animation -------------------*/

  // Vérifie la visibilité des compteurs (scroll + chargement initial).
    function checkCounters() {
        $(".counter").each(function () {
            var counterElement = $(this);
            var endNumber = parseInt(counterElement.data("counter-end"));

            if (isElementInViewport(counterElement) && !counterElement.data("animated")) {
                // Démarrez l'animation du compteur et marquez l'élément comme animé
                animateCounter(counterElement, endNumber);
                counterElement.data("animated", true);
            }
        });
    }

    $(window).on('scroll', checkCounters);
    checkCounters(); // Couvre les compteurs deja visibles au chargement (above-the-fold).

    // Fonction pour vérifier si un élément est visible à l'écran
    function isElementInViewport(el) {
        const rect = el[0].getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Fonction pour animer un compteur à partir de la valeur actuelle jusqu'à la valeur finale.
    function animateCounter(counterElement, endNumber) {
        return new Promise(function(resolve) {
        var currentNumber = endNumber-6;

        function updateCounter() {
            if (currentNumber < endNumber) {
            currentNumber++;
            counterElement.text(currentNumber);
            } else {
            clearInterval(interval);
            resolve(); // Résolve la promesse lorsque le compteur atteint la valeur finale.
            }
        }

        var interval = setInterval(updateCounter, 80); // La mise à jour toutes les 60 millisecondes 
        });
    }

/*------------------ Menu Background  ----------------------*/

    var $navPanel = $('#collapseMenu');
    var $backdrop = $('#menu-backdrop');
    var $navToggle = $('.nav-toggle');

    function setMenuOpen(open) {
        if (open) {
            $navPanel.addClass('is-open').attr('aria-hidden', 'false');
            $backdrop.addClass('is-visible');
            $navToggle.attr('aria-expanded', 'true');
        } else {
            $navPanel.removeClass('is-open').attr('aria-hidden', 'true');
            $backdrop.removeClass('is-visible');
            $navToggle.attr('aria-expanded', 'false');
        }
    }

    $navToggle.on('click', function () {
        setMenuOpen(!$navPanel.hasClass('is-open'));
    });

    $backdrop.on('click', function () {
        setMenuOpen(false);
    });

    // Ferme automatiquement si on passe en desktop
    $(window).on('resize', function () {
        if (window.matchMedia('(min-width: 992px)').matches && $navPanel.hasClass('is-open')) {
            setMenuOpen(false);
        }
    });


});



